module.exports = __webpack_public_path__ + "static/servicios-en-linea-40be839e395a2e079381a13c4ce1bc7f.gif";